<script setup lang="ts">
const { t } = useI18n();

useHead({
  title: "404 - " + t("errors.pages.404.title"),
});
</script>

<template>
  <main class="flex flex-col justify-center items-center w-full h-screen gap-14 bg-ngray-7">
    <site-logo />
    <slot />
  </main>
</template>
